import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { readUrl: String };

  static targets = ['badge'];

  connect() {
    this.dropdownLink = this.element.querySelector('[data-toggle="dropdown"]');
    if (this.dropdownLink) {
      this.boundOnDropdownClick = this.onDropdownClick.bind(this);
      this.dropdownLink.addEventListener('click', this.boundOnDropdownClick);
    }
  }

  disconnect() {
    if (this.dropdownLink) {
      this.dropdownLink.removeEventListener('click', this.boundOnDropdownClick);
    }
  }

  async onDropdownClick() {
    if (this.hasBadgeTarget) {
      try {
        const response = await fetch(this.readUrlValue, {
          method: 'PATCH',
          headers: {
            'X-CSRF-Token': Rails.csrfToken(),
          },
        });

        if (response.ok) {
          this.badgeTarget.remove();
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    }
  }
}
